import angular from 'angular'
import uiRouter from 'angular-ui-router'
import homeComponent from './home.component'
import sidebar from './sidebar/sidebar'
import sharedmoments from './sharedmoments/sharedmoments'
import contributor from './contributor/contributor'
import book from './book/book'
import post from './post/post'

const homeModule = angular.module('home', [
        uiRouter,
        sidebar,
        sharedmoments,
        contributor,
        book,
        post
    ])

    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject'

        $urlRouterProvider.otherwise('/shared-moments')

        $stateProvider
            .state('home', {
                url: '/shared-moments?search',
                component: 'home'
            })
    })

    .component('home', homeComponent)

    .name

export default homeModule



// WEBPACK FOOTER //
// ./client/app/components/home/home.js